if (!customElements.get('mg-product-carousel')) {
  customElements.define('mg-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mg-assortment-track');
      this.controls = this.querySelector('.mg-assortment-controls');
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      if (!this.track || this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const update = () => {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const position = Math.max(0, this.track.scrollLeft);
        this.controls.hidden = max < 2;
        this.buttons[0].disabled = position < 2;
        this.buttons[1].disabled = position >= max - 2;
        const progress = max > 0 ? Math.min(1, (position + this.track.clientWidth) / this.track.scrollWidth) : 1;
        this.style.setProperty('--progress', `${progress * 100}%`);
      };
      const move = direction => {
        const first = this.track.firstElementChild;
        if (!first) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = first.getBoundingClientRect().width + gap;
        const visible = Math.max(1, Math.floor(this.track.clientWidth / step));
        this.track.scrollBy({left: direction * step * visible, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.direction)), {signal}));
      this.track.addEventListener('scroll', update, {passive:true, signal});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal});
      this.resize = new ResizeObserver(update);
      this.resize.observe(this.track);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.resize?.disconnect();
    }
  });
}
